import { Reveal } from "./shared";
import { WHY_VEC } from "../data/content";

export const WhyVec = () => (
    <section data-testid="why-vec-section" className="relative bg-white py-16 lg:py-32 tech-grid">
        <div className="vec-container">
            <Reveal>
                <div className="flex items-center gap-3 font-mono-tech text-[11px] sm:text-xs uppercase tracking-[0.22em] text-vec-green">
                    <span className="text-vec-charcoal/40">SEC 10</span>
                    <span className="h-px w-10 bg-vec-green/50" aria-hidden="true" />
                    <span>Why VEC</span>
                </div>
            </Reveal>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 border-t border-l border-vec-border">                {WHY_VEC.map((item, i) => (
                    <Reveal key={item.num} delay={i * 0.06}>
                        <div
                            data-testid={`why-vec-block-${item.num}`}
                            className="group relative h-full border-b border-r border-vec-border p-8 sm:p-12 bg-white hover:bg-vec-mist/60 transition-colors duration-500"
                        >
                            <span className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold text-vec-green/12 group-hover:text-vec-green/25 transition-colors duration-500 select-none" aria-hidden="true">
                                {item.num}
                            </span>
                            <h3 className="mt-6 font-display text-xl sm:text-2xl lg:text-[1.7rem] font-semibold uppercase tracking-tight text-vec-charcoal leading-snug">
                                {item.title}
                            </h3>
                            <p className="mt-3 max-w-md text-sm sm:text-base leading-relaxed text-vec-charcoal/65">
                                {item.description}
                            </p>
                            <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-vec-green-bright transition-all duration-500 group-hover:w-full" aria-hidden="true" />
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
